<div class="statusInfo px-2 d-flex flex-direction-column g-2">
  <div>
    <mat-chip-set
      aria-label="Status Pending Approval"
      class="status-chip chip-size-m"
      [ngClass]="'Pending Approval' | statusColor"
    >
      <mat-chip>Pending Approval</mat-chip>
    </mat-chip-set>
    <div>All the data needed for approval is in place.</div>
  </div>
  <div>
    <mat-chip-set
      aria-label="Status Approved"
      class="status-chip chip-size-m"
      [ngClass]="'Approvedconnector' | statusColor"
    >
      <mat-chip>Approved</mat-chip>
    </mat-chip-set>
    <div>Connector has been approved - Automation needs to pick this and setup automated downloads</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Automated" class="status-chip chip-size-m" [ngClass]="'Automated' | statusColor">
      <mat-chip>Automated</mat-chip>
    </mat-chip-set>
    <div>Automation process for the connector has started</div>
  </div>
  <div>
    <mat-chip-set
      aria-label="Status Needs Schema Approval"
      class="status-chip chip-size-m"
      [ngClass]="'Needs Schema Approval' | statusColor"
    >
      <mat-chip>Needs Schema Approval</mat-chip>
    </mat-chip-set>
    <div>Automation found change to Schema since last run</div>
  </div>
  <div>
    <mat-chip-set
      aria-label="Status Pending Schema Approval"
      class="status-chip chip-size-m"
      [ngClass]="'Pending Schema Approval' | statusColor"
    >
      <mat-chip>Pending Schema Approval</mat-chip>
    </mat-chip-set>
    <div>
      Scheduled run has been halted, a new Discovery Ingest has been performed and customer has been notified - awaiting
      customer approval
    </div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Success" class="status-chip chip-size-m" [ngClass]="'Success' | statusColor">
      <mat-chip>Success</mat-chip>
    </mat-chip-set>
    <div>Automation process for the connector has started. Last run was successful</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Failure" class="status-chip chip-size-m" [ngClass]="'Failure' | statusColor">
      <mat-chip>Failure</mat-chip>
    </mat-chip-set>
    <div>Automation process for the connector has started. Last run was unsuccessful</div>
  </div>
  <div>
    <mat-chip-set
      aria-label="Status Pending New Run"
      class="status-chip chip-size-m"
      [ngClass]="'Pending Next Run' | statusColor"
    >
      <mat-chip>Pending Next Run</mat-chip>
    </mat-chip-set>
    <div>Last status is not meaningful, any issues from before have been cleared and it is waiting for next run.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Queued" class="status-chip chip-size-m" [ngClass]="'Queued' | statusColor">
      <mat-chip>Queued</mat-chip>
    </mat-chip-set>
    <div>Awaiting execution.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Running" class="status-chip chip-size-m" [ngClass]="'Running' | statusColor">
      <mat-chip>Running</mat-chip>
    </mat-chip-set>
    <div>Ingest is in progress.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Pausing" class="status-chip chip-size-m" [ngClass]="'Pausing' | statusColor">
      <mat-chip>Pausing</mat-chip>
    </mat-chip-set>
    <div>Automation needs to pick this and pause automated downloads</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Paused" class="status-chip chip-size-m" [ngClass]="'Paused' | statusColor">
      <mat-chip>Paused</mat-chip>
    </mat-chip-set>
    <div>Execution temporarily halted, schedules are suspended.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Resuming" class="status-chip chip-size-m" [ngClass]="'Resuming' | statusColor">
      <mat-chip>Resuming</mat-chip>
    </mat-chip-set>
    <div>Automation needs to pick this and resume automated downloads</div>
  </div>
</div>
